export default {
  en: {
    compliant: 'Compliant',
    nonCompliant: 'Non-compliant',
    notScored: 'Not scored',
    notCompliant: 'Not compliant',
    deprecated: 'Deprecated',
    outOfScope: 'Out of scope',
    na: 'N/A',
    unanswered: 'Unanswered',
    scoping: 'Scoping question',
    selected: 'Selected',
    yes: 'Yes',
    no: 'No',
    supplierNotConnected:
      'Your organisation is no longer connected to this supplier. Re-connect with them in order to see their answer to this control.',
  },
};
